import { render, staticRenderFns } from "./manageEmailSecurity.vue?vue&type=template&id=a3c79ee8&scoped=true&"
import script from "./manageEmailSecurity.vue?vue&type=script&lang=tsx&"
export * from "./manageEmailSecurity.vue?vue&type=script&lang=tsx&"
import style0 from "./manageEmailSecurity.vue?vue&type=style&index=0&id=a3c79ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c79ee8",
  null
  
)

export default component.exports